export type AuthChoice = "email" | "code"

export const ns = "authenticationMode"
